/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurementRequest } from './APIMeasurementRequest';
import {
    APIMeasurementRequestFromJSON,
    APIMeasurementRequestFromJSONTyped,
    APIMeasurementRequestToJSON,
} from './APIMeasurementRequest';

/**
 * The serializer that enables the high level PartViewSet. This is basically
 * a simple form of the ArticleSerializer that is optimized to work with
 * the automated quote generation feature.
 * @export
 * @interface APIPartCreationRequest
 */
export interface APIPartCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPartCreationRequest
     */
    name?: string;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPartCreationRequest
     */
    weight?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPartCreationRequest
     */
    length?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPartCreationRequest
     */
    width?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPartCreationRequest
     */
    height?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPartCreationRequest
     */
    volume?: APIMeasurementRequest | null;
    /**
     * 
     * @type {string}
     * @memberof APIPartCreationRequest
     */
    manufacturingProcess: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartCreationRequest
     */
    material: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIPartCreationRequest
     */
    treatments?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIPartCreationRequest
     */
    estimatedPrice?: string;
    /**
     * The guest request that this article was created for.
     * @type {string}
     * @memberof APIPartCreationRequest
     */
    guestRequest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPartCreationRequest
     */
    partId: string;
}

/**
 * Check if a given object implements the APIPartCreationRequest interface.
 */
export function instanceOfAPIPartCreationRequest(value: object): value is APIPartCreationRequest {
    if (!('manufacturingProcess' in value) || value['manufacturingProcess'] === undefined) return false;
    if (!('material' in value) || value['material'] === undefined) return false;
    if (!('partId' in value) || value['partId'] === undefined) return false;
    return true;
}

export function APIPartCreationRequestFromJSON(json: any): APIPartCreationRequest {
    return APIPartCreationRequestFromJSONTyped(json, false);
}

export function APIPartCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPartCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'weight': json['weight'] == null ? undefined : APIMeasurementRequestFromJSON(json['weight']),
        'length': json['length'] == null ? undefined : APIMeasurementRequestFromJSON(json['length']),
        'width': json['width'] == null ? undefined : APIMeasurementRequestFromJSON(json['width']),
        'height': json['height'] == null ? undefined : APIMeasurementRequestFromJSON(json['height']),
        'volume': json['volume'] == null ? undefined : APIMeasurementRequestFromJSON(json['volume']),
        'manufacturingProcess': json['manufacturing_process'],
        'material': json['material'],
        'treatments': json['treatments'] == null ? undefined : json['treatments'],
        'estimatedPrice': json['estimated_price'] == null ? undefined : json['estimated_price'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
        'partId': json['part_id'],
    };
}

export function APIPartCreationRequestToJSON(value?: APIPartCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'weight': APIMeasurementRequestToJSON(value['weight']),
        'length': APIMeasurementRequestToJSON(value['length']),
        'width': APIMeasurementRequestToJSON(value['width']),
        'height': APIMeasurementRequestToJSON(value['height']),
        'volume': APIMeasurementRequestToJSON(value['volume']),
        'manufacturing_process': value['manufacturingProcess'],
        'material': value['material'],
        'treatments': value['treatments'],
        'estimated_price': value['estimatedPrice'],
        'guest_request': value['guestRequest'],
        'part_id': value['partId'],
    };
}

